"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.79,9.09a.33.33,0,0,0-.44-.5c-.77.7-2.08,1.95-2.08,2.55v4.94a1,1,0,1,1-2,0V7.19A1.31,1.31,0,0,0,14,5.88h-.66V3.57A.33.33,0,0,0,13,3.24H4.43a.33.33,0,0,0-.33.33V8.51h9.22v-2H14a.66.66,0,0,1,.65.66v8.89a1.65,1.65,0,0,0,3.3,0V14.31l1.13-.57a.32.32,0,0,0,.18-.29V12.13a.32.32,0,0,0-.32-.33h-1v-.65A8.66,8.66,0,0,1,19.79,9.09ZM12,7.52a.33.33,0,0,1-.33.33H5.74a.33.33,0,0,1-.33-.33V4.89a.33.33,0,0,1,.33-.33h5.93a.33.33,0,0,1,.33.33Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.1,17.4a.33.33,0,0,0,.33.33H13a.33.33,0,0,0,.33-.33V9.17H4.1Zm5.27-5.93a.33.33,0,0,1,.33-.33H11a.33.33,0,0,1,.33.33v2.64a.33.33,0,0,1-.33.33H9.7a.33.33,0,0,1-.33-.33ZM9.7,15.1H11a.33.33,0,1,1,0,.65H9.7a.33.33,0,1,1,0-.65Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;